// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2930":"9a647b6f","3211":"3fbf28e2","5744":"9a647b6f","7819":"3fbf28e2","9246":"3fbf28e2"}[chunkId] + ".chunk.css";
};